module.exports = __webpack_public_path__ + "static/Rahnema3-74784e97ae3aef3923c40b9fbb7a8d70.jpg";